import { format } from 'date-fns'
import { parseApiTimestampToDate } from '@/lib/utils/parseApiTimestamp'

/** Angular `payment_updated_date | date:'yyyy-MM-dd hh:mm:ss a'`. */
export function formatPaymentUpdatedDate(value: unknown): string {
    const d = parseApiTimestampToDate(value)
    return d ? format(d, 'yyyy-MM-dd hh:mm:ss a') : ''
}
